var _rect, _line, _line2, _line3, _line4, _path, _line5, _line6, _path2, _path3, _path4, _path5, _line7, _line8, _line9, _line10, _line11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkCancelInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 0.84082,
    width: 21.9909,
    height: 29.4091,
    rx: 1.25,
    fill: "white",
    stroke: "#717070",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.6543,
    y1: 7.00879,
    x2: 20.7816,
    y2: 7.00879,
    stroke: "#717070"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.6543,
    y1: 9.48145,
    x2: 20.7816,
    y2: 9.48145,
    stroke: "#717070"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.6543,
    y1: 14.4272,
    x2: 20.7816,
    y2: 14.4272,
    stroke: "#717070"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.6543,
    y1: 16.8999,
    x2: 20.7816,
    y2: 16.8999,
    stroke: "#717070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70898 22.6548L5.94535 23.5821L8.41808 21.1094",
    stroke: "#717070"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 9.6543,
    y1: 21.8457,
    x2: 20.7816,
    y2: 21.8457,
    stroke: "#717070"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 9.6543,
    y1: 24.3184,
    x2: 20.7816,
    y2: 24.3184,
    stroke: "#717070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00054 14.3599L8.00038 17.3599",
    stroke: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.3599L7.99994 14.3599",
    stroke: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00054 6.35995L8.00038 9.35988",
    stroke: "#717070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.35986L7.99994 6.35992",
    stroke: "#717070"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 5,
    x2: 2,
    y2: 5,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 10,
    x2: 2,
    y2: 10,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 15,
    x2: 2,
    y2: 15,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 20,
    x2: 2,
    y2: 20,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 25,
    x2: 2,
    y2: 25,
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCancelInvoices);
export default __webpack_public_path__ + "static/media/mark-cancel-invoices.cb621c0fb1d04db17a1b473d8eb96d7f.svg";
export { ForwardRef as ReactComponent };